<template>
  <div>
    <b-form @submit.stop.prevent="handleAddress">
      <div v-if="originalString">
        <h5 v-translate>Original Data Received by Our System</h5>
        <p>{{originalString}}
          <a href="#" @click.prevent="copyToClipboard(originalString, $gettext('text'))" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
          <b-button size="sm" v-b-modal.modalReviewAddressMap @click.stop="openMapOn(originalString)" style="padding: .05rem .25rem; vertical-align: bottom" :title="$gettext('Quick view address on Google Maps in a new window')">
            <font-awesome-icon :icon="['fa', 'map-marked-alt']" size="2x" style="font-size: 10px;vertical-align: middle" />
          </b-button>
        </p>
      </div>

      <div v-if="!editing && (shipping.fields_revision_data &&
        shipping.fields_revision_data[type] &&
        typeof shipping.fields_revision_data[type] === 'object')">
        <h3 v-translate>Multiple possible addresses</h3>
        <p v-translate>Please, select the right address and press "Confirm Address"</p>
        <div v-show="editType === 'radio'">
          <b-form-radio-group id="radio-group-2" v-model="shipping[placeIdParam]" @input="address = null">
            <b-form-radio :value="item" v-for="(item, index) in shipping.fields_revision_data[type]" :key="index" :selected="item.place_id === shipping[placeIdParam]">
              {{ item.main_text }}, {{ item.secondary_text }}
              <b-button size="sm" v-b-modal.modalReviewAddressMap @click.stop="openMapOn(item.main_text + ', ' + item.secondary_text)" style="padding: .05rem .25rem; vertical-align: bottom" :title="$gettext('Quick view address on Google Maps in a new window')">
                <font-awesome-icon :icon="['fa', 'map-marked-alt']" size="2x" style="font-size: 10px;vertical-align: middle" />
              </b-button>
            </b-form-radio>
          </b-form-radio-group>
          <b-button size="sm" style="padding: .25rem 1rem" variant="primary" @click.prevent="editType = 'autocomplete'" class="mt-3" v-translate>
            Change to Autocomplete
          </b-button>
        </div>
        <div v-show="editType !== 'radio'">
          <address-autocomplete ref="address" v-if="!address" @selected="checkThePlace" :minCharacter="4" />
          <p v-else>
            {{address}}
            <b-button variant="danger" size="sm" @click="addressAcInput = ''; address = null" class="py-0 px-1">✕</b-button>
          </p>
          <b-button size="sm" style="padding: .25rem 1rem" variant="primary" @click.prevent="editType = 'radio'" class="mt-3" v-translate>
            Change to Multiple
          </b-button>
        </div>
      </div>
      <div v-if="!editing && (shipping.fields_revision_data &&
        shipping.fields_revision_data[type] &&
        typeof shipping.fields_revision_data[type] === 'string')">
        <h3 v-translate>Address not recognized</h3>
        <p v-translate>Please, use the autocomplete input to search for the right street and number</p>
        <p>
          <span v-translate>Current failed string</span><br/>
          <strong>{{shipping.fields_revision_data[type]}}</strong>
          <a href="#" @click.prevent="copyToClipboard(shipping.fields_revision_data[type], $gettext('text'))" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
          <b-button size="sm" v-b-modal.modalReviewAddressMap @click.stop="openMapOn(shipping.fields_revision_data[type])" style="padding: .05rem .25rem; vertical-align: bottom" :title="$gettext('Quick view address on Google Maps in a new window')">
            <font-awesome-icon :icon="['fa', 'map-marked-alt']" size="2x" style="font-size: 10px;vertical-align: middle" />
          </b-button>
        </p>
        <address-autocomplete ref="address" v-if="!shipping[placeIdParam]" @selected="checkThePlace" :minCharacter="4" />
        <p v-else>
          {{address}}
          <b-button variant="danger" size="sm" @click="addressAcInput = ''; shipping[placeIdParam] = null" class="py-0 px-1">✕</b-button>
        </p>
      </div>
      <div class="mt-3">
        <label for="extra" v-translate>Floor, door, etc.</label>
        <div class="input-group">
          <b-form-input id="extra" v-model="shipping[extraParam]" class="col-12 form-control" />
        </div>
      </div>
      <div class="text-right form-group col-12 form-actions">
        <b-button type="submit" variant="primary" size="lg" v-translate>Confirm Address</b-button>
        <b-button variant="outline-primary" size="lg" @click.prevent="emitCancel" v-translate>Cancel</b-button>
      </div>
    </b-form>
    <b-modal size="lg" id="modalPickPlace" ref="modalPickPlace" hide-footer hide-header @hide="$refs.pickPlaceMap.pickPlace(0, 0)">
      <place-picker ref="pickPlaceMap" hasReference @cancel="closeModalPickPlace" @placePicked="setPlacePicked" centerMap fit-always :zoom="17" />
    </b-modal>
  </div>
</template>

<script>
import AddressMixins from '@/mixins/address.mixin.js'
import AddressAutocomplete from '@/components/AddressAutocomplete'
import PlacePicker from '@/components/PlacePicker'

export default {
  name: 'FixAddressesForm',
  components: {
    AddressAutocomplete,
    PlacePicker
  },
  props: {
    theShipping: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'to'
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      shipping: {},
      address: null,
      placeIdParam: '',
      metaParam: '',
      extraParam: '',
      originalParam: '',
      valid: false,
      editType: 'radio'
    }
  },
  computed: {
    originalString() {
      if (this.shipping.fields_revision_data && this.shipping.fields_revision_data[this.originalParam]) {
        if (this.shipping.fields_revision_data[this.originalParam].address) {
          return this.shipping.fields_revision_data[this.originalParam].address
        } else {
          let str = ''
          str += this.shipping.fields_revision_data[this.originalParam].number ? this.shipping.fields_revision_data[this.originalParam].number + ' ' : ''
          str += this.shipping.fields_revision_data[this.originalParam].street ? this.shipping.fields_revision_data[this.originalParam].street + ',' : ''
          str += this.shipping.fields_revision_data[this.originalParam].city ? this.shipping.fields_revision_data[this.originalParam].city + ',' : ''
          str += this.shipping.fields_revision_data[this.originalParam].state ? this.shipping.fields_revision_data[this.originalParam].state + ',' : ''
          str += window.countries.find(x => x.iso_code === this.shipping.to_country_iso_code).name
          return str
        }
      }
    }
  },
  mixins: [AddressMixins],
  created() {
    if (this.type === 'to') {
      this.placeIdParam = 'to_place_id'
      this.metaParam = 'to_meta'
      this.extraParam = 'to_extra'
      this.originalParam = 'to_original'
    } else {
      this.placeIdParam = 'from_place_id'
      this.metaParam = 'from_meta'
      this.extraParam = 'from_extra'
      this.originalParam = 'from_original'
    }
    this.shipping = {...this.theShipping}
  },
  methods: {
    async checkThePlace(place) {
      await this.checkPlace(place)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.address = this.theCheckedAddress.formatted_address
          this.shipping[this.placeIdParam] = this.theCheckedAddress.id
          this.valid = true
          this.theCheckedAddress = {}
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalPickPlace.show()
          setTimeout(function () {
            this.$refs.pickPlaceMap.center = {
              lat: this.theCheckedAddress.lat,
              lng: this.theCheckedAddress.lng
            }
            this.$refs.pickPlaceMap.reference = this.$refs.address.searchQuery
            this.$refs.pickPlaceMap.styles = 'height: 500px;'
          }.bind(this), 100)
        }
      })
    },
    setPlaceId(placeId) {
      this.shipping[this.placeIdParam] = placeId
      this.valid = true
    },
    setPlacePicked(place) {
      this.address = place.formatted_address
      this.setPlaceId(place.id)
      this.shipping[this.metaParam] = place.reference ? place.reference + ' - ' + (this.shipping[this.metaParam] || '') : this.shipping[this.metaParam]
      this.$refs.modalPickPlace.hide()
    },
    closeModalPickPlace() {
      this.$refs.modalPickPlace.hide()
    },
    async handleAddress() {
      if (!this.valid && this.shipping.fields_revision_data && typeof this.shipping.fields_revision_data[this.type] !== 'string') {
        let placeToCheck = this.shipping[this.placeIdParam]
        await this.checkThePlace(placeToCheck)
      }
      this.$nextTick(() => {
        if (this.shipping[this.placeIdParam] && this.valid) {
          let payload = {
            [this.placeIdParam]: this.shipping[this.placeIdParam],
            [this.metaParam]: this.shipping[this.metaParam],
            [this.extraParam]: this.shipping[this.extraParam]
          }
          this.$http.patch(this.$appConfig.api.baseUrl + 'users/' + this.$store.getters.profile.id + '/shippings/' + this.shipping.id, payload)
            .then(response => {
              this.$emit('shippingupdated', this.shipping)
              this.$emit('success', true)
              this.theCheckedAddress = {}
              this.shipping = {}
              this.valid = false
            })
        }
      })
    },
    emitCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
